/**
 * Anti-stack token
 * ----------------------------------------------------------------------------
 * Shopify groups cart adds with the same `variantId + hash(properties)` into a
 * single line item. For the dashboard's per-unit accounting we want each "Add
 * to cart" to become its own line item even when the variant is identical.
 *
 * Every product form on this theme carries a hidden input with
 *   name="properties[_anti_stack_token]"
 *   data-anti-stack-input
 * rendered with a placeholder value. This script rotates that value to a fresh
 * random string on page load and right before each form submit, so two adds of
 * the same variant always produce two distinct line item keys.
 *
 * The underscore prefix on `_anti_stack_token` keeps the property hidden from
 * customer-facing surfaces (order confirmation, receipts) per Shopify
 * convention. The dashboard ignores it; it has no meaning beyond "make this
 * line unique."
 */
(function () {
  function freshToken() {
    if (window.crypto && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    // Fallback for browsers without crypto.randomUUID (rare).
    return (
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2) +
      Math.random().toString(36).slice(2)
    );
  }

  function rotate(el) {
    el.value = freshToken();
  }

  function rotateAll(root) {
    (root || document).querySelectorAll('[data-anti-stack-input]').forEach(rotate);
  }

  // Initial rotation on page load — covers the Shop Pay / dynamic-checkout path
  // which submits the form natively without going through our submit listener.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      rotateAll();
    });
  } else {
    rotateAll();
  }

  // Rotate right before every Add-to-cart submission. Capture phase so we run
  // before ProductForm's submit handler reads FormData(this.form).
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('js-product-form')) return;
      rotateAll(form);
    },
    true
  );

  // Defense in depth: after any successful cart change, rotate again so the
  // next click in this page has a fresh value (cart drawer typically stays
  // open after an add).
  document.addEventListener('on:cart:add', function () {
    rotateAll();
  });
  document.addEventListener('on:cart:change', function () {
    rotateAll();
  });
})();
